<template>
  <div id="app">
    <Header ref="header"/>
    <router-view @openLogin="openLogin"/>
    <Footer/>
  </div>
</template>

<script>
import Header from './common/Header.vue'
import Footer from './common/Footer.vue'

export default {
  name: 'app',
  components: {
    Header, Footer
  },
  methods: {
    openLogin() {
      // 调用 Header 组件中的登录方法
      this.$refs.header.login();
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
